import { FC } from "react";
import { Spacer } from "shared/layout";
import { Addresses, EmergencyContacts, HomeBases, PhoneNumbers } from "./containers";

export const EditContactDetailsPage: FC = () => {
  return (
    <Spacer size="m">
      <Addresses />
      <PhoneNumbers />
      <EmergencyContacts />
      <HomeBases />
    </Spacer>
  );
};
